import React from "react";
import { Progress } from "antd";
import { calculateEstimateProgress } from "../../utils/progress";
import { formatTimeFromSeconds } from "../../utils/time";

const EstimateProgress = ({ timeEstimate, totalTimeSpent = 0 }) => {
  if (!timeEstimate || timeEstimate <= 0) {
    return <span className="estimate-progress-empty">-</span>;
  }

  const { percentage, color, exceeded, beyondPercentage, beyondColor } =
    calculateEstimateProgress(timeEstimate, totalTimeSpent);

  const tooltip = `Estimate: ${formatTimeFromSeconds(
    timeEstimate
  )} | Spent: ${formatTimeFromSeconds(totalTimeSpent)}`;

  return (
    <div className="estimate-progress" title={tooltip}>
      <Progress
        percent={percentage}
        size="small"
        strokeColor={color}
        format={(percent) => `${percent?.toFixed(1)}%`}
        status={exceeded ? "exception" : "active"}
      />
      {exceeded && (
        <div className="progress-block">
          <Progress
            percent={beyondPercentage}
            size="small"
            strokeColor={beyondColor}
            format={(percent) => `${percent?.toFixed(1)}%`}
            status="exception"
          />
          <span className="progress-label">Beyond estimate</span>
        </div>
      )}
    </div>
  );
};

export default EstimateProgress;
